import type { ReactNode } from 'react';
import { FiCheckCircle, FiXCircle, FiClock, FiArchive, FiTrash2 } from 'react-icons/fi';

export interface ExtensionStatusInput {
  reportStatus?: string | null;
  isArchived?: boolean;
  isDeleted?: boolean;
}

export interface EffectiveExtensionStatus {
  key: 'deleted' | 'suspended' | 'inReview' | 'archived' | 'active';
  label: string;
  color: string;
  icon: ReactNode;
}

/**
 * Collapse an extension's moderation + lifecycle flags into a single status
 * badge. Only one status is shown, chosen by priority (highest first):
 *
 *   Deleted > Suspended > In Review > Archived > Active
 *
 * `reportStatus` covers the suspend/appeal moderation lifecycle
 * ('Active' | 'Suspended' | 'inReview'); `isArchived` / `isDeleted` are the
 * separate lifecycle flags. A missing `reportStatus` is treated as Active.
 */
export function getEffectiveExtensionStatus(ext: ExtensionStatusInput): EffectiveExtensionStatus {
  if (ext.isDeleted) return { key: 'deleted', label: 'Deleted', color: '#8b1a1a', icon: <FiTrash2 /> };
  if (ext.reportStatus === 'Suspended') return { key: 'suspended', label: 'Suspended', color: '#e74c3c', icon: <FiXCircle /> };
  if (ext.reportStatus === 'inReview') return { key: 'inReview', label: 'In Review', color: '#f39c12', icon: <FiClock /> };
  if (ext.isArchived) return { key: 'archived', label: 'Archived', color: '#8b949e', icon: <FiArchive /> };
  return { key: 'active', label: 'Active', color: '#27ae60', icon: <FiCheckCircle /> };
}
